import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Row, Col, Input, Button } from 'antd';
const { TextArea } = Input;
@inject('approvePermissionStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
  }
  handleOk=()=>{
    const {approvePermissionStore, handleCancel,record } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      approvePermissionStore.onAgreeAction({
        "description": fieldsValue.description,
        "id": record.id,
        "status": 2
      });
      handleCancel()
    }).catch(err => {})

  }
  render() {
    const { addModalVisible, handleCancel } = this.props
    return (
      <>
        <Modal
          title='Refuse Description'
          closable={false}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type='primary' onClick={this.handleOk}>Save</Button>,
            <Button key="Cancel" onClick={handleCancel}>Cancel</Button>,
          ]}
        >
          <Form ref={this.formRef} key='addMapping'>
            <Row justify='start' gutter={[10,10]}>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='description' label="Description" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Please enter Description without special characters.',pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                  <TextArea rows={4} placeholder="Please enter ..." />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}

export default FormModal;
